import gql from 'graphql-tag';

/**
 * Campi "propri" del Good360 (layer editoriale/curation) + il nome del Good, per:
 *  - il fetcher di EntityEditFetcher delle sezioni edit su Good360 (descrizioni, config correlati);
 *  - i riepiloghi delle card del dialogo Good360.
 */
export const Good360SelfEditQuery = gql`
	query Good360SelfEditQuery($id: ID!) {
		entity: node(id: $id) {
			id
			... on Good360 {
				status
				description
				editorialDescription
				relatedSameCategory
				relatedSameTrend
				relatedSameClaim
				relatedSameCompany
				relatedMax
				evidences {
					id
					type
				}
				Good {
					id
					name
				}
			}
		}
	}
`;